import { Education } from '../../model/clergy-bio-app-models';

export interface ClergyBioEducationFormModel {
	theological: Education[],
	other: Education[],
}

export const theologicalDegreeOptions = [
	'BA', 'Certificate', 'DMin', 'LTh', 'MA', 'MDiv', 'MTh', 'PhD', 'STB', 'STM', 'Other',
];

export const otherDegreeOptions = [
	'AA', 'BA', 'BS', 'Certificate', 'JD', 'MA', 'MBA', 'MEd', 'MS', 'PhD', 'Other',
];

export const theologicalSchools = [
	'Andover Newton Theological School',
	'Berkeley Divinity School at Yale',
	'Bexley Hall Seminary',
	'Bexley-Seabury',
	'Boston University',
	'Candler School of Theology Emory University',
	'Church Divinity School of the Pacific',
	'Colgate Rochester Crozer Divinity School',
	'Drew University',
	'Duke Divinity School',
	'Episcopal Divinity School',
	'Episcopal Theological School Claremont Bloy House',
	'Episcopal Theological Seminary of the Southwest',
	'Fuller Theological Seminary',
	'General Theological Seminary',
	'Harvard Divinity School',
	'Nashotah House',
	'Oxford University GB',
	'Princeton Theological Seminary',
	'Seabury-Western Theological Seminary',
	'Sewanee: The University of the South, School of Theology',
	'Southern Methodist University Perkins',
	'Trinity Episcopal School for Ministry',
	'Union Theological Seminary',
	'University of Chicago',
	'Vanderbilt University',
	'Virginia Theological Seminary',
	'Yale Divinity School',
	'Other',
];